import logo from './logo.svg';
import './App.css';
// import GenA from '.  /Genetic ALgo/GenA';
// import Sine1 from './sine_sim/Sine1';
import Pi from './Pi.js/Pi';
import Color_m from './Colour_pred/Color_m';
import Cnn1 from './CNN_ml/Cnn1';
import Cnn2 from './CNN_ml_ditto/Cnn2';
// import Flappy_Bird from './Flappy_bird';
import Flappy_Bird from './flappy_bird/Flappy_Bird';
// import Test from './Test_fb/Test';
import Moli from './Mono_lisa_main/Moli';

function App() {
  return (
    <div className="App">
      {/* <GenA /> */}
      {/* <Sine1 /> */}
      {/* <Pi /> */}
      {/* <Color_m /> */}
      {/* <Cnn1 /> */}
      {/* <Cnn2 /> */}
      <Flappy_Bird />
      {/* <Test /> */}
      {/* <Moli /> */}
      </div>
  );
}

export default App;
